var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    { class: _vm.classes, attrs: { to: _vm.campaignRoute } },
    [
      _c(
        "c-card",
        { staticClass: "card", attrs: { "data-cy": "campaign-card" } },
        [
          _c("campaign-tag", {
            staticClass: "tag",
            attrs: {
              "is-cashback": _vm.isCashback && !_vm.campaign.value,
              "discount-type":
                _vm.tagSymbol === "%" ? "percentage" : "currency",
              "show-discont-tag": !_vm.isNextToYou,
              "discount-value": +_vm.tagValue,
              "discount-symbol": _vm.tagSymbol,
              "is-exclusive": _vm.isExclusive,
              "from-now-discount-value": _vm.campaign.discounted_value,
              "is-from-now": _vm.tagSymbol === "de-por",
              "is-award": _vm.campaign.event === "award",
              "is-engagement": _vm.campaign.event === "engagement"
            }
          }),
          _vm._v(" "),
          !_vm.isNextToYou && _vm.isCashback && _vm.campaign.value
            ? _c("campaign-tag", {
                staticClass: "tag",
                attrs: {
                  bottom: "",
                  "is-cashback": _vm.isCashback,
                  "discount-type":
                    _vm.cashbackSymbol === "%" ? "percentage" : "currency",
                  "discount-value": +_vm.cashbackValue,
                  "discount-symbol": _vm.cashbackSymbol
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("c-image", {
            staticClass: "image",
            attrs: {
              src: _vm.image,
              alt: _vm.campaign.title,
              placeholder: require("@/assets/img/campaign-placeholder.svg"),
              "is-background": ""
            }
          }),
          _vm._v(" "),
          _vm.square
            ? [
                !_vm.isNextToYou
                  ? _c("h4", { staticClass: "partner" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.campaign.title) + "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isNextToYou
                  ? _c("div", { staticClass: "distance" }, [
                      _c("p", { staticClass: "partner" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.adjustedPartnerName) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("k-icon", {
                            attrs: { size: "10", icon: "map-marker" }
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.campaign.distance) +
                              " km\n        "
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass: "description",
                    class: _vm.isNextToYou ? "-next-to-you" : ""
                  },
                  [
                    _c("div", { staticClass: "partner" }, [
                      _c("h4", { staticClass: "name" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.adjustedPartnerName) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "title" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.campaign.title) +
                          "\n        "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.hasFavorite
                  ? _c("c-button", {
                      staticClass: "favorite",
                      class: { "-favorited": _vm.campaign.is_favorited },
                      attrs: {
                        size: "md",
                        "data-cy": "campaign-card-favorite-button",
                        icon: _vm.campaign.is_favorited
                          ? "filled-bookmark"
                          : "bookmark"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.handleAnalytics.apply(null, arguments)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isNextToYou
                  ? _c("div", { staticClass: "distance -card" }, [
                      _c(
                        "div",
                        [
                          _c("k-icon", {
                            attrs: { size: "10", icon: "map-marker" }
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.campaign.distance) +
                              " km\n        "
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.expiry && !_vm.search
                  ? _c(
                      "p",
                      { staticClass: "expiry" },
                      [
                        _c("k-icon", {
                          attrs: { size: "15", icon: "alarm-clock" }
                        }),
                        _vm._v(
                          "\n        Expira em " +
                            _vm._s(_vm.expiry) +
                            " " +
                            _vm._s(_vm.localTest) +
                            "\n      "
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a5d2b7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a5d2b7f","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaign/CampaignCard.vue
// module id = 2119
// module chunks = 1610